import React, { useEffect } from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchConsultations, setCurrentPage } from "../../redux/slices/consultationSlice";
import TableComponent from "../../components/common/TableComponent";
import StatusBadge from "../../components/details/Shared/StatusBadge";
import { FiDownload } from "react-icons/fi";

export default function Consultations() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const consultations = useSelector((state) => state.consultations.items);
  const status = useSelector((state) => state.consultations.status);
  const pagination = useSelector((state) => state.consultations.pagination);

  useEffect(() => {
    dispatch(fetchConsultations(1)); // Start with page 1
  }, [dispatch]);

  const handlePageChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const columns = [
    { key: "petParent", label: "Pet Parent" },
    {
      key: "pet",
      label: "Pet",
      render: (val, row) => (
        <>
          {val} {row.breed && <span className="text-gray-400">({row.breed})</span>}
        </>
      ),
    },
    { key: "veterinarian", label: "Veterinarian" },
    { key: "datetime", label: "Date & Time" },
    { key: "type", label: "Type" },
    {
      key: "status",
      label: "Status",
      render: (val) => <StatusBadge status={val} />
    },
  ];

  const renderCell = (key, value, row) => {
    if (key === "pet" && row.breed) {
      return (
        <>
          {value} <span className="text-gray-400">({row.breed})</span>
        </>
      );
    }
    if (key === "status") {
      return <StatusBadge status={value} />;
    }
    return value;
  };

  const handleRowClick = (row) => {
    navigate(`/swift-app/admin/consultation/${row.uuid}`);
  };

  // Navigate to ExportPage
  // const handleExportClick = () => {
  //   navigate(`/swift-app/admin/export?tab=Consultations`);
  // };

  return (
    <div className="px-3 sm:px-6 md:px-8 lg:px-12 pt-6 md:pt-8 font-inter min-h-screen bg-white">
      {/* ✅ Header */}
      <div className="flex flex-col gap-4">
        {/* Top Row — Back button + Title + Export */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              aria-label="Go Back"
              className="p-2 md:p-3 text-lg md:text-xl text-gray-800 hover:text-blue-600"
            >
              <MdOutlineArrowBackIos />
            </button>
            <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900">
              Consultations
            </h1>
          </div>

        {/* ✅ Responsive Export button */}
             {/* Icon always visible */}
          {/* <button
            onClick={handleExportClick}
            className="flex items-center justify-center gap-2 bg-blue-500 text-white font-medium px-3 sm:px-4 md:px-5 py-2 rounded-lg shadow hover:bg-blue-600 transition"
          >
         
            <FiDownload className="w-5 h-5" />
            <span className="hidden lg:inline">Export</span>
          </button> */}
        </div>

        {/* Subtitle */}
        <p className="text-gray-600 text-sm sm:text-base ml-10 md:ml-14">
          Manage appointment tracker
        </p>
      </div>

      {/* ✅ Table */}
      <div className="mt-8 md:mt-10 overflow-x-auto">
        {status === "loading" ? (
          <div className="text-center text-gray-500 py-10 text-sm md:text-base">
            Loading...
          </div>
        ) : (
          <TableComponent
            columns={columns}
            data={consultations}
            renderCell={renderCell}
            onRowClick={handleRowClick}
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            totalItems={pagination.totalItems}
            itemsPerPage={pagination.itemsPerPage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
}
